import React from "react";
import { connect } from "react-redux";

import UserProfile from "../../../app/partials/layout/UserProfile";
import InquiryManagementNoti from "../../../app/partials/layout/InquiryManagementNoti";
import checkPermission from "../../../app/libs/permission";
import Notification from "../../../app/partials/layout/Notification";

class Topbar extends React.Component {
	render() {
		const { page, pageSubmenu, user = {}, notiList, setPageNoti, setReloadNoti } = this.props;

		return (
			<div className={`kt-header__topbar ${page?.content || pageSubmenu?.content ? 'w-100 d-flex justify-content-between align-items-center' : ''}`}>
				{page?.content || pageSubmenu?.content ?
					<div className='default-black-color'>
						<span className='f-semibold_30'>{user?.is_marker === 1 && page?.content === 'Dashboard' ? 'Review Test' : (page?.content || pageSubmenu?.content)}</span>
					</div>
					: <></>}
				<div className="d-flex">
					{checkPermission('inquiry.view') ? <InquiryManagementNoti /> : <></>}
					{user?.is_marker === 1 ? <></> : <Notification notiList={notiList} setPageNoti={setPageNoti} setReloadNoti={setReloadNoti} />}
					<UserProfile isNewUI={true} showAvatar={true} showHi={false} showBadge={false} />
				</div>
			</div>
		)
	}
}

const mapStateToProps = ({ auth: { user } }) => ({
	user: user ?? {},
});

export default connect(mapStateToProps)(Topbar);
